export class GetActivitiesForMonthRequest {
  public cmd: string = "get_activities_for_month";
  constructor(public majlis: string, public month: string, public year: string) { }
}
